var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('div',{staticClass:"text-right",class:{ 'col-md-12': _vm.vfg }},[_c('b-button',{staticClass:"btn-anchor raised",on:{"click":function($event){return _vm.$emit('submit')}}},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5d9b5ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/buttons/form/SubmitButton.vue
// module id = null
// module chunks = 